'use client';

import React, { useEffect, useState } from 'react';

interface DesktopOnlyProps {
  children: React.ReactNode;
  minWidth?: number;
}

export const DesktopOnly: React.FC<DesktopOnlyProps> = ({ children, minWidth = 1024 }) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(`(min-width: ${minWidth}px)`);
    const update = () => setIsDesktop(media.matches);
    update();
    media.addEventListener('change', update);
    return () => media.removeEventListener('change', update);
  }, [minWidth]);

  if (!isDesktop) {
    return null;
  }

  return <>{children}</>;
};
